import type { OnMessageCallback, TopicName, TopicsPayloads } from '../types'
import { getConfig } from '@/tools/config'
import { glovoRum } from '@/tools/o11y/client'

export const initKaspiWebView = () => {
  const { isBrowser } = getConfig()
  if (!isBrowser) {
    return
  }

  window.kaspiSubscribers = {
    oauth: () => {},
    opay: () => {},
    setCloseButtonState: () => {},
    getCurrentGeolocation: () => {},
    isGeoNavigationEnabled: () => {},
  }

  glovoRum.setContext('isKaspi', 'true')
}

export const postMessage = (
  topic: TopicName,
  params: TopicsPayloads[TopicName],
  callback?: OnMessageCallback
): void => {
  if (callback) {
    window.kaspiSubscribers[topic] = callback
  }
  const payload = getPayload(topic, params)
  window.partners.send(topic, payload, `window.kaspiSubscribers.${topic}`)
}

export const isKaspiApiMethodSupported = (method: string): boolean =>
  window.partners.isSupports(method)

const stringifyPayload = (payload: unknown) => JSON.stringify(payload, null, 1).replaceAll('\n', '')

export const getPayload = <T extends TopicName>(topic: T, params: TopicsPayloads[T]): string => {
  const { kaspiClientId, kaspiPartnerId, kaspiOauthUrl, kaspiOpayUrl } = getConfig()

  switch (topic) {
    case 'oauth': {
      const payload = {
        launchUrl: `${kaspiOauthUrl}?${new URLSearchParams({
          ...(params as TopicsPayloads['oauth']),
          client_id: kaspiClientId,
          response_type: 'code',
          scope: 'openid',
        }).toString()}`,
      }
      return stringifyPayload(payload)
    }
    case 'opay': {
      const { transportId } = params as TopicsPayloads['opay']
      const payload = {
        launchUrl: `${kaspiOpayUrl}?${new URLSearchParams({
          transportId,
          partnerId: kaspiPartnerId,
          redirectUrl: `https://glovo.com/?transportId=${transportId}`,
        }).toString()}`,
      }
      return stringifyPayload(payload)
    }
    case 'setCloseButtonState': {
      return stringifyPayload(params)
    }
    case 'getCurrentGeolocation': {
      return stringifyPayload(params)
    }
    case 'isGeoNavigationEnabled': {
      return stringifyPayload(params)
    }
  }
}
